import React, { useState, useEffect, useRef, useMemo } from 'react';
import {
  Text,
  TextInput,
  TouchableOpacity,
  Modal,
  View,
  ActivityIndicator,
  Platform,
  Image,
  ScrollView,
  TextStyle,
  ViewStyle,
} from 'react-native';
import { Picker } from '@react-native-picker/picker';
import { launchImageLibrary } from 'react-native-image-picker';
import { Editor } from 'primereact/editor';
import { actions, RichEditor, RichToolbar } from 'react-native-pell-rich-editor';
import { SafeAreaView } from 'react-native-safe-area-context';
import Checkbox from 'expo-checkbox';
import { FontAwesome5 } from '@expo/vector-icons';

import {
  createProductFamily,
  updateProductFamily,
  getProductCategoriesData,
} from '../../../../api/Product';
import { getBrandsData } from '../../../../api/Price';
import { getPriceGroupsData } from '../../../../api/Price';
import BasicModalContainer from '../../../../common/components/basicmodal/BasicModalContainer';
import ModalHeader from '../../../../common/components/basicmodal/ModalHeader';
import ModalBody from '../../../../common/components/basicmodal/ModalBody';
import ModalFooter from '../../../../common/components/basicmodal/ModalFooter';
import { API_URL } from '../../../../common/constants/AppConstants';
import { msgStr } from '../../../../common/constants/Message';
import { useAlertModal } from '../../../../common/hooks';

import { productFamilyModalstyles } from './styles/ProductFamilyModalStyle';

const AddProductFamilyModal = ({
  isModalVisible,
  family,
  comboItemsData,
  setUpdateProductFamilyTrigger,
  closeModal,
}) => {
  const isUpdate = family ? true : false;

  const { showAlert } = useAlertModal();
  const [ValidMessage, setValidMessage] = useState('');
  const [familyError, setFamilyError] = useState('');
  const [comboItemsError, setComboItemsError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [callInit, setCallInit] = useState(false);

  const [categories, setCategories] = useState([]);
  const [PriceGroups, setPriceGroups] = useState([]);

  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [familyTxt, setFamilyTxt] = useState('');
  const [displayNameTxt, setDisplayNameTxt] = useState('');
  const [summaryTxt, setSummaryTxt] = useState('');
  const [notesTxt, setNotesTxt] = useState('');
  const [selectedCategory, selectCategory] = useState<any>({});
  const [selectedPriceGroup, selectPriceGroup] = useState({});
  // const [trackingTagTxt, setTrackingTagTxt] = useState('');

  const [brands, setBrands] = useState([]);
  const [associatedBrandIds, setAssociatedBrandIds] = useState([]);
  const [isCombo, setIsCombo] = useState(false);
  const [selectedComboItems, setSelectedComboItems] = useState([]);
  const [selectedComboItemId, setSelectedComboItemId] = useState('');

  const inputRef = useRef(null);
  const defaultInputRef = useRef(null);

  const richText = useRef();

  const [descHTML, setDescHTML] = useState('');
  const [showDescError, setShowDescError] = useState(false);

  const handleBrandSelection = (brandId) => {
    if (associatedBrandIds.includes(brandId)) {
      setAssociatedBrandIds(associatedBrandIds.filter((id) => id !== brandId));
    } else {
      setAssociatedBrandIds([...associatedBrandIds, brandId]);
    }
  };

  const checkFamilyInput = () => {
    if (!familyTxt.trim()) {
      setFamilyError(msgStr('emptyField'));
    } else {
      setFamilyError('');
    }
  };

  // Function to handle combo item selection
  const handleComboItemSelection = (itemId) => {
    if (itemId && itemId !== '') {
      const selectedItem = comboItemsList.find((item: any) => String(item.id) === String(itemId));
      if (selectedItem) {
        setSelectedComboItems((prevItems) => {
          const existingIndex = prevItems.findIndex((item) => item.id === selectedItem.id);
          if (existingIndex !== -1) {
            // If already exists, increment quantity
            const updatedItems = [...prevItems];
            updatedItems[existingIndex].quantity += 1;
            return updatedItems;
          } else {
            // If new, add with quantity 1
            return [
              ...prevItems,
              {
                display_name: selectedItem.display_name,
                id: selectedItem.id,
                quantity: 1,
              },
            ];
          }
        });

        // Clear combo items error when user selects an item
        setComboItemsError('');
      }
      setSelectedComboItemId(''); // Reset picker
    }
  };

  // Function to remove combo item
  const removeComboItem = (indexToRemove) => {
    setSelectedComboItems((prevItems) => {
      const updatedItems = [...prevItems];
      if (updatedItems[indexToRemove].quantity > 1) {
        updatedItems[indexToRemove].quantity -= 1;
      } else {
        updatedItems.splice(indexToRemove, 1);
      }
      return updatedItems;
    });
  };

  const handleComboToggle = () => {
    setIsCombo(!isCombo);
    if (isCombo) {
      // If unchecking combo, clear combo items and error
      setSelectedComboItems([]);
      setComboItemsError('');
    }
  };

  const clearAllErrors = () => {
    setFamilyError('');
    setComboItemsError('');
  };

  useEffect(() => {
    getBrandsData((jsonRes) => {
      setBrands(jsonRes);
    });
  }, []);

  const richTextHandle = (descriptionText) => {
    if (descriptionText) {
      setShowDescError(false);
      setDescHTML(descriptionText);
    } else {
      setShowDescError(true);
      setDescHTML('');
    }
  };

  const submitContentHandle = () => {
    const replaceHTML = descHTML.replace(/<(.|\n)*?>/g, '').trim();
    const replaceWhiteSpace = replaceHTML.replace(/&nbsp;/g, '').trim();

    if (replaceWhiteSpace.length <= 0) {
      setShowDescError(true);
    } else {
      // send data to your server!
    }
  };

  useEffect(() => {
    if (isModalVisible) {
      defaultInputRef.current && defaultInputRef.current.focus();
      clearAllErrors(); // Clear all errors when modal opens
    }
    setAssociatedBrandIds([]);
    setSelectedComboItems([]);
  }, [isModalVisible]);

  useEffect(() => {
    if (callInit) {
      setValidMessage('');
      if (family && categories) {
        const initalCategory = categories.find((category) => {
          return category.id == family.category_id;
        });
        if (initalCategory) selectCategory(initalCategory);
      } else if (categories.length > 0) {
        selectCategory(categories[0]);
      }

      console.log(family);
      setFamilyTxt(family ? family.family : '');
      setDisplayNameTxt(family ? family.display_name : '');
      // setTrackingTagTxt(family ? family.tracking_tag : '');
      setSummaryTxt(family ? family.summary : '');
      setNotesTxt(family ? family.notes : '');
      setImagePreviewUrl(family ? API_URL + family.img_url : '');
      setSelectedImage(null);
      setIsCombo(family ? family.is_combo : false);
      inputRef.current = null;

      // Initialize combo items if editing
      if (family && family.combo_items) {
        try {
          const comboItems = typeof family.combo_items === 'string' ? JSON.parse(family.combo_items) : family.combo_items;
          setSelectedComboItems(comboItems);
        } catch (error) {
          console.log('Error parsing combo items:', error);
        }
      }

      if (family && PriceGroups) {
        const initalGroup = PriceGroups.find((priceGroup) => {
          return priceGroup.id == family.price_group_id;
        });
        if (initalGroup) selectPriceGroup(initalGroup);
      } else if (PriceGroups.length > 0) {
        selectPriceGroup(PriceGroups[0]);
      }
      setIsLoading(false);
    }
  }, [callInit]);

  useEffect(() => {
    if (isModalVisible) {
      loadProductCategoriesData(() => {
        loadPriceGroupsData(() => {
          setCallInit(true);
        });
      });
      if (family?.brand_ids) setAssociatedBrandIds(JSON.parse(family.brand_ids));
      else setAssociatedBrandIds([]);
    } else {
      setAssociatedBrandIds([]);
      setSelectedComboItems([]);
    }
  }, [isModalVisible]);

  const loadProductCategoriesData = (callback) => {
    getProductCategoriesData((jsonRes, status, error) => {
      switch (status) {
        case 200:
          setCategories(jsonRes);
          callback();
          break;
        case 500:
          showAlert('error', msgStr('serverError'));
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          break;
      }
    });
  };

  const loadPriceGroupsData = (callback) => {
    getPriceGroupsData((jsonRes, status, error) => {
      switch (status) {
        case 200:
          setPriceGroups(jsonRes);
          callback();
          break;
        case 500:
          showAlert('error', msgStr('serverError'));
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          break;
      }
    });
  };

  const handleImageSelection = (event) => {
    const file = Platform.OS == 'web' ? event.target.files[0] : event.nativeEvent.target.files[0];

    const imagePreviewUrl = URL.createObjectURL(file);
    setSelectedImage(file);
    setImagePreviewUrl(imagePreviewUrl);
  };

  const handleImageUpload = () => {
    const options: any = {
      title: 'Select Image',
      storageOptions: {
        skipBackup: true,
        path: 'images',
      },
    };

    launchImageLibrary(options, (response: any) => {
      if (response.didCancel) {
        console.log('User cancelled image picker');
      } else if (response.error) {
        console.log('Image picker error: ', response.error);
      } else {
        let imageUri = response.uri || response.assets?.[0]?.uri;
        setImagePreviewUrl(imageUri);
      }
    });
  };

  const AddFamilyButtonHandler = () => {
    let hasErrors = false;

    // Validate family name
    if (!familyTxt.trim()) {
      setFamilyError(msgStr('emptyField'));
      hasErrors = true;
    } else {
      setFamilyError('');
    }

    // Validate combo items
    if (isCombo && selectedComboItems.length === 0) {
      setComboItemsError('Please select at least one combo item when combo is enabled');
      hasErrors = true;
    } else {
      setComboItemsError('');
    }

    // If any validation fails, return early
    if (hasErrors) {
      return;
    }

    setIsLoading(true);

    console.log(displayNameTxt || familyTxt);

    const formData = new FormData();
    formData.append('family', familyTxt);
    formData.append('display_name', displayNameTxt || familyTxt);
    // formData.append('tracking_tag', trackingTagTxt);
    formData.append('category_id', selectedCategory.id);
    if (selectedImage) formData.append('img', selectedImage);
    formData.append('summary', summaryTxt);
    formData.append('notes', notesTxt);
    formData.append('brand_ids', JSON.stringify(associatedBrandIds));
    formData.append('combo_items', JSON.stringify(selectedComboItems));
    formData.append('is_combo', isCombo ? '1' : '0');
    // formData.append('price_group_id', selectedPriceGroup.id);

    const handleResponse = (jsonRes, status) => {
      switch (status) {
        case 201:
          showAlert('success', jsonRes.message);
          setUpdateProductFamilyTrigger(true);
          closeModal();
          break;
        case 409:
          setValidMessage(jsonRes.error);
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          closeModal();
          break;
      }
      setIsLoading(false);
    };

    if (isUpdate) {
      formData.append('id', family.id);
      updateProductFamily(formData, (jsonRes, status) => {
        handleResponse(jsonRes, status);
      });
    } else {
      createProductFamily(formData, (jsonRes, status) => {
        handleResponse(jsonRes, status);
      });
    }
  };

  const comboItemsList = useMemo(() => {
    const itemwithoutCombo = comboItemsData.filter((item: any) => item.is_combo == false);
    return itemwithoutCombo.sort((a: any, b: any) =>
      String(a.display_name ?? a.family ?? '').localeCompare(String(b.display_name ?? b.family ?? ''))
    );
  }, [comboItemsData]);
  return (
    <Modal
      animationType="none"
      transparent={true}
      visible={isModalVisible}
      onShow={() => {
        setCallInit(false);
      }}
      onRequestClose={() => {
        setCallInit(false);
      }}
    >
      <BasicModalContainer>
        <ModalHeader label={'Product Family'} closeModal={closeModal} />
        <ModalBody>
          <View style={{ flexDirection: 'row' }}>
            {/* Left Section */}
            <View style={{ paddingRight: 20, width: 400 }}>
              <Text style={styles.label}>Combo</Text>
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginVertical: 10,
                  marginLeft: 10,
                }}
              >
                <Checkbox value={isCombo} onValueChange={handleComboToggle} />
                <Text style={{ marginLeft: 10 }}>Yes</Text>
              </View>

              <Text style={styles.label}>Category</Text>
              <Picker
                style={[styles.select, { marginBottom: 10 }]}
                selectedValue={selectedCategory.id}
                onValueChange={(itemValue, itemIndex) => {
                  selectCategory(categories[itemIndex]);
                }}
              >
                {categories.length > 0 &&
                  categories.map((category, index) => {
                    return (
                      <Picker.Item key={index} label={category.category} value={category.id} />
                    );
                  })}
              </Picker>

              <Text style={styles.label}>Family</Text>
              <TextInput
                style={styles.input}
                placeholder="Family"
                value={familyTxt}
                onChangeText={(text) => {
                  setFamilyTxt(text);
                  // Clear error when user starts typing
                  if (familyError) setFamilyError('');
                }}
                placeholderTextColor="#ccc"
                onBlur={checkFamilyInput}
                ref={defaultInputRef}
              />
              {familyError.trim() !== '' && <Text style={[styles.message, { marginTop: -5, marginBottom: 5 }]}>{familyError}</Text>}

              <Text style={styles.label}>Display Name</Text>
              <TextInput
                style={styles.input}
                placeholder="Display Name"
                value={displayNameTxt}
                onChangeText={setDisplayNameTxt}
                placeholderTextColor="#ccc"
              />

              {/* <Text style={styles.label}>Tracking Tag</Text>
              <TextInput
                style={styles.input}
                placeholder="Tracking"
                value={trackingTagTxt}
                onChangeText={setTrackingTagTxt}
                placeholderTextColor="#ccc"
              /> */}

              {isCombo && (
                <>
                  <Text style={styles.label}>Combo Items</Text>
                  <Picker
                    style={[styles.select, { marginBottom: 10 }]}
                    selectedValue={selectedComboItemId}
                    onValueChange={(itemValue) => {
                      setSelectedComboItemId(itemValue);
                      handleComboItemSelection(itemValue);
                    }}
                  >
                    <Picker.Item label="Select a combo item..." value="" />
                    {comboItemsList.length > 0 &&
                      comboItemsList.map((item, index) => {
                        return (
                          <Picker.Item key={index} label={item.display_name || item.family} value={item.id} />
                        );
                      })}
                  </Picker>

                  {/* Combo Items Error Message */}
                  {comboItemsError.trim() !== '' && (
                    <Text style={[styles.message, { marginTop: -5, marginBottom: 5 }]}>{comboItemsError}</Text>
                  )}

                  {/* Selected Combo Items Display Box */}
                  <View style={styles.selectedComboItemsContainer}>
                    <Text style={styles.selectedComboItemsTitle}>Selected Combo Items:</Text>
                    <ScrollView style={styles.selectedComboItemsScrollView}>
                      {selectedComboItems.length === 0 ? (
                        <Text style={styles.noItemsText}>No items selected</Text>
                      ) : (
                        selectedComboItems?.map((item, index) => (
                          <View key={`${item.id}-${index}`} style={styles.selectedComboItem}>
                            <Text style={styles.selectedComboItemText}>
                              <Text style={{ fontWeight: 'bold' as TextStyle['fontWeight'] }}>{item.quantity}x</Text>{' '}{' '}
                              {item.display_name}
                            </Text>
                            <TouchableOpacity
                              style={styles.removeButton}
                              onPress={() => removeComboItem(index)}
                            >
                              <FontAwesome5 name="times" size={14} color="white" />
                            </TouchableOpacity>
                          </View>
                        ))
                      )}
                    </ScrollView>
                  </View>
                </>
              )}

              {Platform.OS == 'web' && (
                <View style={styles.imagePicker}>
                  <TouchableOpacity
                    style={styles.imageUpload}
                    onPress={() => inputRef.current.click()}
                  >
                    {imagePreviewUrl ? (
                      <Image source={{ uri: imagePreviewUrl }} style={styles.previewImage} />
                    ) : (
                      <View>
                        <Text style={styles.boxText}>Click to choose an image</Text>
                      </View>
                    )}
                  </TouchableOpacity>
                  <input
                    type="file"
                    ref={inputRef}
                    style={styles.fileInput}
                    onChange={handleImageSelection}
                  />
                </View>
              )}
              {Platform.OS != 'web' && (
                <>
                  <TouchableOpacity onPress={handleImageUpload}>
                    <Text>Upload Image</Text>
                  </TouchableOpacity>
                  {imagePreviewUrl && (
                    <Image source={{ uri: imagePreviewUrl }} style={{ width: 200, height: 200 }} />
                  )}
                </>
              )}

              {/* <Text style={styles.label}>Price Group</Text>
              <Picker
                style={styles.select}
                selectedValue={selectedPriceGroup.id}
                onValueChange={(itemValue, itemIndex) => {
                  selectPriceGroup(PriceGroups[itemIndex]);
                }}
              >
                {PriceGroups.length > 0 &&
                  PriceGroups.map((item, index) => {
                    return <Picker.Item key={index} label={item.price_group} value={item.id} />;
                  })}
              </Picker> */}
            </View>

            {/* Middle Section */}
            <View style={{ paddingRight: 30, width: 700 }}>
              <Text style={styles.label}>Summary</Text>
              {/* <TextInput
                style={[styles.input, styles.textarea]}
                placeholder="Summary"
                placeholderTextColor="#ccc"
                multiline={true}
                numberOfLines={4}
                value={summaryTxt}
                onChangeText={setSummaryTxt}
              /> */}
              {(Platform.OS == 'android' || Platform.OS == 'ios') && (
                <SafeAreaView>
                  <View style={styles.richTextContainer}>
                    <RichEditor
                      ref={richText}
                      onChange={richTextHandle}
                      placeholder=""
                      style={styles.richTextEditorStyle}
                      initialHeight={250}
                    />
                    <RichToolbar
                      editor={richText}
                      selectedIconTint="#873c1e"
                      iconTint="#312921"
                      actions={[
                        actions.insertImage,
                        actions.setBold,
                        actions.setItalic,
                        actions.insertBulletsList,
                        actions.insertOrderedList,
                        actions.insertLink,
                        actions.setStrikethrough,
                        actions.setUnderline,
                      ]}
                      style={styles.richTextToolbarStyle}
                    />
                  </View>
                </SafeAreaView>
              )}
              {Platform.OS == 'web' && (
                <Editor
                  value={summaryTxt}
                  onTextChange={(e) => setSummaryTxt(e.htmlValue)}
                  style={{ height: 175, marginBottom: '10px' }}
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                />
              )}

              <Text style={styles.label}>Notes</Text>
              {Platform.OS == 'web' && (
                <Editor
                  value={notesTxt}
                  onTextChange={(e) => setNotesTxt(e.htmlValue)}
                  style={{ height: 175, marginBottom: '10px' }}
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                />
              )}
            </View>

            {/* Right Section */}
            <View style={{ marginRight: 20 }}>
              <Text style={{ marginBottom: 8, fontSize: 20 }}>{'Associated Brands'}</Text>
              {brands.length > 0 &&
                brands.map((brand) => (
                  <View
                    key={brand.id}
                    style={{
                      flexDirection: 'row',
                      alignItems: 'center',
                      marginVertical: 10,
                      marginLeft: 10,
                    }}
                  >
                    <Checkbox
                      value={associatedBrandIds.includes(brand.id)}
                      onValueChange={() => handleBrandSelection(brand.id)}
                    />
                    <Text style={{ marginLeft: 10 }}>{brand.brand}</Text>
                  </View>
                ))}
            </View>
          </View>
        </ModalBody>
        <ModalFooter>
          {ValidMessage.trim() != '' && <Text style={[styles.message, { marginTop: -5 }]}>{ValidMessage}</Text>}
          <TouchableOpacity onPress={AddFamilyButtonHandler}>
            <Text style={styles.addButton}>{isUpdate ? 'Update' : 'Add'}</Text>
          </TouchableOpacity>
        </ModalFooter>
      </BasicModalContainer>
      {isLoading && (
        <View style={styles.overlay}>
          <ActivityIndicator size="large" color="#0000ff" />
        </View>
      )}
    </Modal>
  );
};

const additionalStyles = {
  selectedComboItemsContainer: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 5,
    padding: 10,
    marginTop: 10,
    marginBottom: 15,
    backgroundColor: '#f9f9f9',
  },
  selectedComboItemsTitle: {
    fontSize: 14,
    fontWeight: 'bold' as TextStyle['fontWeight'],
    marginBottom: 8,
    color: '#333',
  },
  selectedComboItemsScrollView: {
    maxHeight: 150,
  },
  noItemsText: {
    fontSize: 12,
    color: '#888',
    fontStyle: 'italic' as TextStyle['fontStyle'],
  },
  selectedComboItem: {
    flexDirection: 'row' as ViewStyle['flexDirection'],
    justifyContent: 'space-between' as ViewStyle['justifyContent'],
    alignItems: 'center' as ViewStyle['alignItems'],
    backgroundColor: '#fff',
    padding: 8,
    marginBottom: 5,
    borderRadius: 3,
    borderWidth: 1,
    borderColor: '#e0e0e0',
  },
  selectedComboItemText: {
    fontSize: 12,
    color: '#333',
    flex: 1,
  },
  removeButton: {
    backgroundColor: '#ff4444',
    borderRadius: 12,
    width: 20,
    height: 20,
    justifyContent: 'center' as ViewStyle['justifyContent'],
    alignItems: 'center' as ViewStyle['alignItems'],
    marginLeft: 10,
  }
};

const styles = { ...productFamilyModalstyles, ...additionalStyles };

export default AddProductFamilyModal;